/**
 * ExpandedDial — the dialpad panel (opened via Ctrl+Shift+D, pill click, or
 * click-to-dial). Container-agnostic.
 */

import { DialPad } from '../DialPad';

export function ExpandedDial({ onClose }: { onClose: () => void }) {
  return (
    <div className="p-2">
      <DialPad onClose={onClose} />
    </div>
  );
}
